var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:google-icon",
    clipPath: "url(#clip0_1224_30420)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7614 10.1871C19.7614 9.36767 19.6949 8.76973 19.551 8.14966H10.1943V11.848H15.6865C15.5758 12.7671 14.9778 14.1512 13.6491 15.0813L13.6304 15.2051L16.5888 17.4969L16.7938 17.5174C18.6762 15.7789 19.7614 13.221 19.7614 10.1871Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1937 19.9313C12.8844 19.9313 15.1432 19.0454 16.7932 17.5174L13.6484 15.0813C12.8069 15.6682 11.6774 16.0779 10.1937 16.0779C7.55834 16.0779 5.32163 14.3395 4.5243 11.9366L4.40743 11.9466L1.33124 14.3273L1.29102 14.4391C2.92979 17.6945 6.29598 19.9313 10.1937 19.9313Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.52478 11.9366C4.31439 11.3165 4.19264 10.6521 4.19264 9.96559C4.19264 9.27902 4.31439 8.61467 4.51371 7.9946L4.50813 7.86253L1.3934 5.4436L1.29149 5.49208C0.616073 6.84299 0.228516 8.36002 0.228516 9.96559C0.228516 11.5712 0.616073 13.0881 1.29149 14.439L4.52478 11.9366Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.1937 3.85336C12.065 3.85336 13.3273 4.66168 14.047 5.33718L16.8596 2.59107C15.1322 0.985496 12.8844 0 10.1937 0C6.29598 0 2.92979 2.23672 1.29102 5.49214L4.51323 7.99466C5.32163 5.59183 7.55834 3.85336 10.1937 3.85336Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1224_30420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.542,
    height: 20,
    fill: "white",
    transform: "translate(0.228516)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.eb0f39435ccde3080d706a11150b20f2.svg";
export { ForwardRef as ReactComponent };